import React, { Component } from "react";
import { Link } from "react-router-dom";
import Layout from "./../layouts/Index";
import BlockLoader from "./../contentloaders/BlockLoader";
import { connect } from "react-redux";
import {
  Row,
  Col,
  Container,
  Table,
  Modal,
  Form,
  Button,
  FormControl,
  InputGroup,
} from "react-bootstrap";
import {
  getUsers,
  addUser,
  getMoreUsers,
  searchUser,
  searchedUsers,
} from "./../../store/actions/UserActions";
import { titleCase } from "./../../utils/index";
import { createSchema } from "./../../helpers/validation/user";
import { toast } from "react-toastify";
import { Formik } from "formik";
import { FaPlus, FaSearch } from "react-icons/fa";

class Index extends Component {
  constructor(props) {
    super(props);

    this.user = React.createRef();

    this.state = {
      showModal: false,

      count: 0,

      loading: false,

      user_search_term: "",

      privilege: 0,
    };
  }

  componentDidMount = async () => {
    this.setState({
      loading: true,
      privilege: parseInt(localStorage.getItem("ltdn_priv")),
    });

    const result = await this.props.getUsers();

    if (result) {
      this.setState({ loading: false });
    }
  };

  componentWillUnmount = () => {};

  toggleModal = () => {
    this.setState({ showModal: !this.state.showModal });
  };

  createUser = async (values) => {
    try {
      this.setState({ loading: true });

      if (values.email === "") {
        delete values.email;
      }

      const result = await this.props.addUser(values);

      if (result) {
        toast.success("New User Details Created Successfully !", {
          position: "bottom-center",
        });

        this.setState({ showModal: false, loading: false });

        await this.props.getUsers();
      }
    } catch (error) {
      this.setState({ loading: false });

      if (error.response !== undefined || error.response !== null) {
        if (error?.response?.data?.message) {
          toast.warning(`${error?.response?.data?.message}`, {
            position: "bottom-center",
          });
        } else if (error?.response?.data?.error) {
          toast.warning(`${error?.response?.data?.error}`, {
            position: "bottom-center",
          });
        } else if (error.response.status === 409) {
          toast.warning(
            "Specific Field In Your Form Exists In The Database !",
            {
              position: "bottom-center",
            }
          );
        } else {
          toast.warning(
            "We could not finish your request. Please try again later !",
            {
              position: "bottom-center",
            }
          );
        }
      }
    }
  };

  fetchMoreUsers = async () => {
    try {
      this.setState({ loading: true });

      const {
        users: { next_page },
      } = this.props;

      const result = await this.props.getMoreUsers(next_page);

      if (result) {
        this.setState({ loading: false });
      }
    } catch (error) {
      console.log(error);
    }
  };

  searchUser = async () => {
    this.setState({ loading: true });
    try {
      const { user_search_term } = this.state;

      let obj = {};

      if (user_search_term !== "") {
        obj.user_search_term = user_search_term;
      }

      const result = await this.props.searchUser(obj);

      if (result) {
        await this.props.searchedUsers(result);

        toast.success("User Found !", {
          position: "bottom-center",
        });
      }else {
        toast.warning("User Not Found!", {
          position: "bottom-center",
        });
      }
    } catch (error) {
        if (error.response !== undefined && (error.response.status === 404 || error.response.status === 400)) {
          toast.warning("User Not Found!", {
            position: "bottom-center",
          });
        }
      } finally {
        this.setState({ loading: false });
      }
  };

  keyPress = async (e) => {
    try {
      if (e.keyCode === 13) {
        await this.searchUser();
      }
    } catch (error) {
      console.log(error);
    }
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  refresh = async () => {
    this.setState({ loading: true });

    const result = await this.props.getUsers();

    if (result) {
      this.setState({ loading: false, user_search_term: "" });
    }
  };

  render() {
    const {
      users,
      users: { page, pages },
    } = this.props;

    const { loading, user_search_term, privilege } = this.state;

    return (
      <Layout>
      <Col sm="12" style={{ minHeight: "80vh", padding: "1.5em 0" }}>
        <Container>
        <Row>
          <Col xs="12" md="6" lg="4" className="mb-3 mx-auto">
            <Form
              onSubmit={async (e) => {
                e.preventDefault();
                if (!user_search_term?.trim()) return; // must have at least one
                await this.searchUser();
              }}
            >
              <InputGroup>
                  <FormControl
                    type="text"
                    placeholder="Search Phone/Email"
                    name="user_search_term"
                    value={this.state.user_search_term}
                    onKeyDown={this.keyPress}
                    onChange={this.handleChange}
                    className="rounded-pill shadow-sm"
                  />
                  {/* Clear Button (X) */}
                  {(this.state.user_search_term?.trim()) && (
                    <Button
                      variant="outline-secondary"
                      onClick={() => {
                        this.setState({ user_search_term: "" }, () => {
                          this.refresh();
                        });
                      }}
                      className="rounded-circle shadow-sm d-flex align-items-center justify-content-center ms-2"
                      style={{
                        width: "40px",
                        height: "40px",
                        padding: 0,
                      }}
                    >
                      ×
                    </Button>
                  )}
                  {/* Search Button */}
                  <Button
                    variant="success"
                    type="submit"
                    disabled={
                      !this.state.user_search_term?.trim()
                    }
                    className="rounded-circle shadow-sm d-flex align-items-center justify-content-center ms-2"
                    style={{
                      width: "40px",
                      height: "40px",
                      padding: 0,
                    }}
                  >
                    <FaSearch size={16} />
                  </Button>
                </InputGroup>
            </Form>
          </Col>

          {/* Responsive header and actions */}
          <Col sm="12" className="mb-3">
            <div className="d-flex flex-row justify-content-between align-items-center">
              <h3 className="mb-0">Users</h3>

              {loading ? (
                <div style={{ width: "40px", height: "32px" }}>
                  <BlockLoader
                    width="40px"
                    height="32"
                    innerHeight="100%"
                    innerWidth="100%"
                    style={{
                      borderRadius: "4px",
                      backgroundColor: "#e0e0e0",
                    }}
                  />
                </div>
              ) : (
                <Button
                  variant="success"
                  size="sm"
                  className="d-flex align-items-center justify-content-center"
                  style={{ width: "32px", height: "32px", padding: "0" }}
                  onClick={() => this.toggleModal()}
                  disabled={privilege === 2 || privilege === 1 ? false : true}
                >
                  <FaPlus size={14} />
                </Button>
              )}
            </div>
          </Col>

          {/* Responsive Table */}
          <Col xs={12}>
          {!loading && (
            <div style={{ overflowX: "auto" }}>
            <Table
              striped
              bordered
              hover
              size="lg"
              variant="light"
              responsive="sm"
              className="users-table"
            >
              <thead>
              <tr>
                <th>#</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Username</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Date Joined</th>
                <th>#</th>
              </tr>
              </thead>
              <tbody>
              {users.data.map((user, i) => (
                <tr key={i} ref={this.user}>
                <td data-label="#"> {i + 1}</td>
                <td data-label="First Name">
                  {user.first_name !== null
                  ? titleCase(user.first_name)
                  : "N/A"}
                </td>
                <td data-label="Last Name">
                  {user.last_name !== null
                  ? titleCase(user.last_name)
                  : "N/A"}
                </td>
                <td data-label="Username">
                  {user.username !== null
                  ? titleCase(user.username)
                  : "N/A"}
                </td>
                <td data-label="Email" style={{
                  wordBreak: "break-all",
                  overflowWrap: "break-word",
                  whiteSpace: "normal"
                }}>
                  {user.email !== null
                  ? titleCase(user.email)
                  : "N/A"}
                </td>
                <td data-label="Phone">{user.msisdn}</td>
                <td data-label="Date Joined">
                  {new Date(user.date_created).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "short",
                      day: "numeric"
                    })
                  }
                  </td>
                <td
                  style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  }}
                  data-label="Actions"
                >
                  <Button
                  variant="info"
                  size="sm"
                  as={Link}
                  to={`/admin/users/${user.id}`}
                  style={{ marginRight: "10px", color: "#fff" }}
                  >
                  View
                  </Button>
                  {(privilege === 2 || privilege === 1) && (
                  <Button
                    variant="primary"
                    size="sm"
                    as={Link}
                    to={`/admin/users/${user.id}/edit`}
                  >
                    Edit
                  </Button>
                  )}
                </td>
                </tr>
              ))}
              </tbody>
            </Table>
            </div>
          )}
          </Col>

          <Col xs={12}>
          {loading && (
            <BlockLoader
            width="100%"
            height="400px"
            innerWidth="100%"
            innerHeight="100%"
            style={{ marginBottom: "2em" }}
            />
          )}
          </Col>

          {page < pages && (
          <Col
            xs={12}
            className="d-flex flex-column align-items-center justify-content-center mt-4"
          >
            <Button
            variant="primary"
            size="lg"
            onClick={() => this.fetchMoreUsers()}
            disabled={loading}
            >
            {loading === true ? "Loading ..." : "Load More"}
            </Button>
          </Col>
          )}
        </Row>
        </Container>
      </Col>

      {/* Add responsive table styles */}
      <style>{`
        @media (max-width: 767px) {
        .users-table thead {
          display: none;
        }
        .users-table, .users-table tbody, .users-table tr, .users-table td {
          display: block;
          width: 100%;
        }
        .users-table tr {
          margin-bottom: 1rem;
          border-bottom: 2px solid #dee2e6;
        }
        .users-table td {
          text-align: right;
          padding-left: 50%;
          position: relative;
          border: none;
          border-bottom: 1px solid #dee2e6;
        }
        .users-table td:before {
          content: attr(data-label);
          position: absolute;
          left: 0;
          width: 50%;
          padding-left: 1rem;
          font-weight: bold;
          text-align: left;
          white-space: nowrap;
        }
        }
      `}</style>
      <Modal show={this.state.showModal} onHide={this.toggleModal} size="lg">
        <Modal.Header closeButton>
        <Modal.Title>New User</Modal.Title>
        </Modal.Header>

        <Formik
        initialValues={{
          first_name: "",
          last_name: "",
          username: "",
          msisdn: "",
          email: "",
          status: "",
          privilege: "",
          password: "",
          confirm_password: "",
        }}
        validationSchema={createSchema}
        onSubmit={async (values, { setSubmitting, resetForm }) => {
          this.createUser(values);
        }}
        >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
        }) => (
          <div>
          <Modal.Body>
            <Row>
            <Form.Group as={Col} xs={12} md={6} controlId="first_name">
              <Form.Label column sm="12">
              Firstname
              </Form.Label>
              <Col sm="12">
              <Form.Control
                type="text"
                placeholder="Firstname"
                name="first_name"
                isValid={touched.first_name && !errors.first_name}
                isInvalid={errors.first_name && touched.first_name}
                value={values.first_name}
                onChange={handleChange}
              />
              {errors.first_name && touched.first_name && (
                <Form.Control.Feedback type="invalid">
                {errors.first_name}
                </Form.Control.Feedback>
              )}
              </Col>
            </Form.Group>

            <Form.Group as={Col} xs={12} md={6} controlId="last_name">
              <Form.Label column sm="12">
              Lastname
              </Form.Label>
              <Col sm="12">
              <Form.Control
                type="text"
                placeholder="Lastname"
                name="last_name"
                isValid={touched.last_name && !errors.last_name}
                isInvalid={errors.last_name && touched.last_name}
                value={values.last_name}
                onChange={handleChange}
              />
              {errors.last_name && touched.last_name && (
                <Form.Control.Feedback type="invalid">
                {errors.last_name}
                </Form.Control.Feedback>
              )}
              </Col>
            </Form.Group>
            </Row>

            <Row>
            <Form.Group as={Col} xs={12} controlId="username">
              <Form.Label column sm="12">
              Username
              </Form.Label>
              <Col sm="12">
              <Form.Control
                type="text"
                placeholder="Username"
                name="username"
                isValid={touched.username && !errors.username}
                isInvalid={errors.username && touched.username}
                value={values.username}
                onChange={handleChange}
              />
              {errors.username && touched.username && (
                <Form.Control.Feedback type="invalid">
                {errors.username}
                </Form.Control.Feedback>
              )}
              </Col>
            </Form.Group>
            </Row>

            <Row>
            <Form.Group as={Col} xs={12} md={6} controlId="email">
              <Form.Label column sm="12">
              Email
              </Form.Label>
              <Col sm="12">
              <Form.Control
                type="text"
                placeholder="Email"
                name="email"
                isValid={touched.email && !errors.email}
                isInvalid={errors.email && touched.email}
                value={values.email}
                onChange={handleChange}
              />
              {errors.email && touched.email && (
                <Form.Control.Feedback type="invalid">
                {errors.email}
                </Form.Control.Feedback>
              )}
              </Col>
            </Form.Group>

            <Form.Group as={Col} xs={12} md={6} controlId="msisdn">
              <Form.Label column sm="12">
              Phone Number
              </Form.Label>
              <Col sm="12">
              <Form.Control
                type="text"
                placeholder="Phone Number"
                name="msisdn"
                isValid={touched.msisdn && !errors.msisdn}
                isInvalid={errors.msisdn && touched.msisdn}
                value={values.msisdn}
                onChange={handleChange}
              />
              {errors.msisdn && touched.msisdn && (
                <Form.Control.Feedback type="invalid">
                {errors.msisdn}
                </Form.Control.Feedback>
              )}
              </Col>
            </Form.Group>
            </Row>

            <Row>
            <Form.Group as={Col} xs={12} md={6} controlId="privilege">
              <Form.Label column sm="12">
              Privilege
              </Form.Label>
              <Col sm="12">
              <Form.Control
                as="select"
                isValid={touched.privilege && !errors.privilege}
                defaultValue={values.privilege}
                isInvalid={errors.privilege && touched.privilege}
                name="privilege"
                onChange={handleChange}
                onBlur={handleBlur}
              >
                <option>Choose ...</option>
                <option value={0}>Non Admin</option>
                {localStorage.getItem("ltdn_priv") === "2" && <option value={1}>Admin</option>}
              </Form.Control>
              {errors.privilege && touched.privilege && (
                <Form.Control.Feedback type="invalid">
                {errors.privilege}
                </Form.Control.Feedback>
              )}
              </Col>
            </Form.Group>

            <Form.Group as={Col} xs={12} md={6} controlId="status">
              <Form.Label column sm="12">
              Status
              </Form.Label>
              <Col sm="12">
              <Form.Control
                as="select"
                isValid={touched.status && !errors.status}
                defaultValue={values.status}
                isInvalid={errors.status && touched.status}
                name="status"
                onChange={handleChange}
                onBlur={handleBlur}
              >
                <option>Choose ...</option>
                <option value={0}>Inactive</option>
                <option value={1}>Active</option>
              </Form.Control>
              {errors.status && touched.status && (
                <Form.Control.Feedback type="invalid">
                {errors.status}
                </Form.Control.Feedback>
              )}
              </Col>
            </Form.Group>
            </Row>

            <Row>
            <Form.Group as={Col} xs={12} md={6} controlId="password">
              <Form.Label column sm="12">
              Password
              </Form.Label>
              <Col sm="12">
              <Form.Control
                type="text"
                placeholder="Password"
                name="password"
                isValid={touched.password && !errors.password}
                isInvalid={errors.password && touched.password}
                value={values.password}
                onChange={handleChange}
              />
              {errors.password && touched.password && (
                <Form.Control.Feedback type="invalid">
                {errors.password}
                </Form.Control.Feedback>
              )}
              </Col>
            </Form.Group>

            <Form.Group as={Col} xs={12} md={6} controlId="confirm_password">
              <Form.Label column sm="12">
              Confirm Password
              </Form.Label>
              <Col sm="12">
              <Form.Control
                type="text"
                placeholder="Confirm Password"
                name="confirm_password"
                isValid={
                touched.confirm_password && !errors.confirm_password
                }
                isInvalid={
                errors.confirm_password && touched.confirm_password
                }
                value={values.confirm_password}
                onChange={handleChange}
              />
              {errors.confirm_password &&
                touched.confirm_password && (
                <Form.Control.Feedback type="invalid">
                  {errors.confirm_password}
                </Form.Control.Feedback>
                )}
              </Col>
            </Form.Group>
            </Row>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={this.toggleModal}>
            Close
            </Button>

            <Button
            variant="primary"
            onClick={handleSubmit}
            disabled={loading}
            >
            Create User
            </Button>
          </Modal.Footer>
          </div>
        )}
        </Formik>
      </Modal>
      </Layout>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    users: state.users,
  };
};

export default connect(mapStateToProps, {
  getUsers,
  addUser,
  getMoreUsers,
  searchUser,
  searchedUsers,
})(Index);
